module.exports = __webpack_public_path__ + "img/close-outline.d7cc8ce5.svg";